import React from 'react';
import { Hero } from '../components/home/Hero';
import { CategoryShowcase } from '../components/home/CategoryShowcase';
import { BestSellers } from '../components/home/BestSellers';
import { CompareTypes } from '../components/home/CompareTypes';
import { BatteryAdvisor } from '../components/home/BatteryAdvisor';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { BrandStrip } from '../components/home/BrandStrip';
export function Home() {
  return <>
      <Hero data-id="element-755" data-mp="24gsg0eyt680d" />
      <CategoryShowcase data-id="element-756" data-mp="24g8uypdv33i4" />
      <div className="h-12 lg:h-16" aria-hidden="true" data-id="element-757" data-mp="24hk8vi10trmy" />
      <BestSellers data-id="element-758" data-mp="29gdekoa2geck" />
      <CompareTypes data-id="element-759" data-mp="29f28uix28wit" />
      <ReviewsSection data-id="element-760" data-mp="29ek4t045pe0c" />
      <BatteryAdvisor data-id="element-761" data-mp="29i7vlri7vmbd" />
      <BrandStrip data-id="element-762" data-mp="2dhgsv6cgu2bo" />
    </>;
}